import { FC } from "react";
import styled from "@emotion/styled";
import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { observer } from "mobx-react-lite";
import {
  CustomVocabularySettings,
  SmartFormattingSettings,
} from "@/pages/settings/components/voice-mode";

export const SettingsVoiceModePage: FC = observer(() => {
  return (
    <StyledSettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Voice mode">
        <CustomVocabularySettings />
        <Divider />
        <SmartFormattingSettings />
      </SettingsSubsectionWrapper>
    </StyledSettingsSectionWrapper>
  );
});

const StyledSettingsSectionWrapper = styled(SettingsSectionWrapper)`
  max-width: 100%;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.border.default};
  margin: ${({ theme }) => `${theme.spacing[4]} 0`};
`;
